import { Link } from 'react-router-dom';

import styles from './LandingHeader.module.css';

const logoUrl = `${process.env.PUBLIC_URL}/imagotipo-blanco.svg`;
const contactHref = 'mailto:luis@truedata.com.mx,dipepere@truedata.com.mx?subject=TRUE POS';

/** Public header shared by TRUE product pages (same markup and styles as TrueTicket). */
const LandingHeader = ({ signedIn }: { signedIn: boolean }) => (
  <header className={styles.header}>
    <div className={styles.container}>
      <Link to="/pos" className={styles.logoContainer}>
        <img src={logoUrl} alt="TRUE" className={styles.logo} />
        <div className={styles.divider} />
        <span className={styles.brandText}>POS</span>
      </Link>

      <nav className={styles.nav}>
        <a href="#funciones" className={`${styles.navLink} ${styles.navLinkOptional}`}>Funciones</a>
        <a href="#descargar" className={`${styles.navLink} ${styles.navLinkOptional}`}>Descargar</a>
        <a href={contactHref} className={`${styles.navLink} ${styles.navLinkOptional}`}>Contacto</a>
        {signedIn ? (
          <Link to="/admin" className={styles.navButton}>Ir al panel</Link>
        ) : (
          <>
            <Link to="/login" className={styles.navLink}>Iniciar sesión</Link>
            <Link to="/register" className={styles.navButton}>Comenzar gratis</Link>
          </>
        )}
      </nav>
    </div>
  </header>
);

export default LandingHeader;
